var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtnEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 12.5769H14V13.5H1V12.5769ZM11.8643 4.73077C12.2357 4.36154 12.2357 3.80769 11.8643 3.43846L10.1929 1.77692C9.82143 1.40769 9.26429 1.40769 8.89286 1.77692L1.92857 8.7V11.6538H4.9L11.8643 4.73077ZM9.54286 2.42308L11.2143 4.08462L9.82143 5.46923L8.15 3.80769L9.54286 2.42308ZM2.85714 10.7308V9.06923L7.5 4.45385L9.17143 6.11538L4.52857 10.7308H2.85714Z",
    fill: "#F57C1F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnEdit);
export default __webpack_public_path__ + "static/media/btn-edit.de5c534dc246c66bd855f358d21c32ca.svg";
export { ForwardRef as ReactComponent };